import Image from "next/image";
import TrashIcon from "@/components/cartDrawer/trashIcon.svg";

export const GiftCardCartItem = ({ giftCard, onClick }: any) => {
  return (
    <div
      className="flex flex-col justify-between items-center py-4 border-b"
      data-testid="gift-card-cart-item"
    >
      <div className="w-full flex flex-row justify-between">
        <div className="w-full flex flex-col justify-between">
          <p className="text-lg text-[#373737] max-w-[310px]">Gift Card</p>
          <div className="max-w-[80%]">
            {!giftCard.recipient?.isCustomer && (
              <ul className="list-disc ml-6 text-[15px] text-[#727272] space-y-1">
                {giftCard.recipient?.name && (
                  <li>{giftCard.recipient?.name}</li>
                )}
                {giftCard.recipient?.email && (
                  <li>{giftCard.recipient.email}</li>
                )}
                {giftCard.note && (
                  <li className="max-w-[310px]">
                    <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                      {giftCard.note}
                    </div>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
        <div className="flex flex-col justify-start items-end">
          <p className="text-[16px] font-medium mt-0.5">
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
            }).format(giftCard.amount)}
          </p>
          <button onClick={onClick} className="mt-2">
            <Image
              src={TrashIcon.src}
              height={14}
              width={14}
              alt="remove gift card"
            />
          </button>
        </div>
      </div>
    </div>
  );
};
